import React from 'react';
import { useTheme } from 'ThemeContext';
import { Spacer, Wrapper } from './WidgetSpacer.style';

function WidgetSpacer() {
  const theme = useTheme();
  return (
    <Wrapper>
      <Spacer theme={theme.widgetSpacer.spacer} />
    </Wrapper>
  );
}

export default WidgetSpacer;
